const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "have",
        type: "address"
      },
      {
        internalType: "address",
        name: "want",
        type: "address"
      }
    ],
    name: "OnlyCoordinatorCanFulfill",
    type: "error"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "_requestId",
        type: "uint256"
      }
    ],
    name: "RequestTicketMinting",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
        name: "_mintType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_saleSchedule",
        type: "uint256"
      }
    ],
    name: "SaleScheduleUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_userAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "_requestId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_successApostleIdArray",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_failTicketIdArray",
        type: "uint256[]"
      }
    ],
    name: "TicketMintSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_userAddress",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_gene",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_iv",
        type: "uint256"
      }
    ],
    name: "TicketMintingSuccess",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "TicketMintingRequestStructMap",
    outputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address"
      },
      {
        internalType: "bool",
        name: "isDone",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "apostleContract",
    outputs: [
      {
        internalType: "contract ApeironApostle",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
        name: "_mintType",
        type: "uint8"
      }
    ],
    name: "getSkillIds",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_requestId",
        type: "uint256"
      }
    ],
    name: "getTicketMintingStructsByRequestId",
    outputs: [
      {
        components: [
          {
            internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
            name: "mintType",
            type: "uint8"
          },
          {
            internalType: "address",
            name: "ticketContractAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "ticketId",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "gene",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "apostleId",
            type: "uint256"
          }
        ],
        internalType: "struct ApeironApostleTicketMinting.TicketMintingStruct[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "isEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "requestId",
        type: "uint256"
      },
      {
        internalType: "uint256[]",
        name: "randomWords",
        type: "uint256[]"
      }
    ],
    name: "rawFulfillRandomWords",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_ticketContractAddressArray",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "_ticketIdArray",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "_ticketCountArray",
        type: "uint256[]"
      }
    ],
    name: "requestTicketMinting",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "s_randomWords",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "s_subscriptionId",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "_gasLimit",
        type: "uint32"
      },
      {
        internalType: "uint16",
        name: "_requestConfirmations",
        type: "uint16"
      },
      {
        internalType: "uint32",
        name: "_numWords",
        type: "uint32"
      },
      {
        internalType: "bytes32",
        name: "_keyHash",
        type: "bytes32"
      }
    ],
    name: "setChainlinkPara",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_isEnabled",
        type: "bool"
      }
    ],
    name: "setEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
        name: "_mintType",
        type: "uint8"
      },
      {
        internalType: "uint256",
        name: "_time",
        type: "uint256"
      }
    ],
    name: "setForSaleSchedule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "ticketContractIdToApostleClassMapping",
    outputs: [
      {
        internalType: "enum ApostleMeta.ApostleClass",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "ticketContractIdToMintTypeMapping",
    outputs: [
      {
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
        name: "",
        type: "uint8"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
        name: "",
        type: "uint8"
      }
    ],
    name: "ticketMintTypeGeneMapping",
    outputs: [
      {
        internalType: "uint256",
        name: "minIV",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxIV",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "minSkillLevel",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "maxSkillLevel",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "totalSkillLevel",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_nftAddress",
        type: "address"
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "chainlinkSubscriptionId",
            type: "uint64"
          },
          {
            internalType: "address",
            name: "vrfCoordinator",
            type: "address"
          },
          {
            internalType: "bytes32",
            name: "keyHash",
            type: "bytes32"
          }
        ],
        internalType: "struct ChainlinkRngUpgradeable.ChainlinkStruct",
        name: "_chainlinkStruct",
        type: "tuple"
      }
    ],
    name: "updateContractSetting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum ApostleMeta.ApostleClass[]",
        name: "_classArray",
        type: "uint8[]"
      },
      {
        internalType: "address[]",
        name: "_ticketContractAddressArray",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "_ticketIdArray",
        type: "uint256[]"
      }
    ],
    name: "updateTicketContractIdToApostleClassMapping",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE[]",
        name: "_mintTypeArray",
        type: "uint8[]"
      },
      {
        internalType: "address[]",
        name: "_ticketContractAddressArray",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "_ticketIdArray",
        type: "uint256[]"
      }
    ],
    name: "updateTicketContractIdToMintTypeMapping",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "enum ApeironApostleTicketMinting.TICKET_MINT_TYPE",
        name: "_mintType",
        type: "uint8"
      },
      {
        components: [
          {
            internalType: "uint256[]",
            name: "classArray",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "minIV",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxIV",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "minSkillLevel",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "maxSkillLevel",
            type: "uint256"
          },
          {
            internalType: "uint256[]",
            name: "skillIds",
            type: "uint256[]"
          },
          {
            internalType: "uint256",
            name: "totalSkillLevel",
            type: "uint256"
          }
        ],
        internalType: "struct ApeironApostleTicketMinting.TicketMintTypeGeneStruct",
        name: "_ticketMintTypeGeneStruct",
        type: "tuple"
      }
    ],
    name: "updateTicketMintTypeInfo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=polygon-apostle-ticket-mint.json.js.map
